export { default } from './product-card-horizontal';